<template>
  <div ref="root" class="home-root">
    <div class="home-hero">
      <img :src="$assets.homeHero"/>
      <div class="home-date uk">
        <p>02 &bull; 02 &bull; 2020</p>
        <p>Porthpean House, Cornwall</p>
      </div>
      <div class="home-date za">
        <p>25 &bull; 04 &bull; 2020</p>
        <p>Simonsig, Stellenbosch</p>
      </div>
      <div class="home-down-arrow">
        <font-awesome-icon icon="chevron-down"/>
      </div>
    </div>
    <div class="home-2">
      <img :src="$assets.home2"/>
    </div>
    <div class="mariette-smile">
      <img :src="$assets.marietteSmile"/>
    </div>
    <div class="rock">
      <img :src="$assets.rock"/>
    </div>
    <div class="camping">
      <img :src="$assets.camping"/>
    </div>
    <div class="stives">
      <img :src="$assets.homeStives"/>
    </div>
    <div class="gs-wedding">
      <img :src="$assets.gsWedding"/>
    </div>
    <div class="snow-love">
      <img :src="$assets.snowLove"/>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'home',
  }
</script>

<style lang="scss" scoped>
  .home-root {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: auto;

    & > div {
      $switch-at: 800px;

      /*
            &:not(:first-child)  {
              @media (max-width: $switch-at) {
                background-size: contain;
                -o-background-size: contain;
                -moz-background-size: contain;
                -webkit-background-size: contain;
                height: 100vh;
                background-position-y: center !important;
              }
            }
            @media (min-width: $switch-at) {
              background-size: cover;
              -o-background-size: cover;
              -moz-background-size: cover;
              -webkit-background-size: cover;
              height: 130vh;
            }
      */
      width: 100%;
      height: 130vh;

      &:last-child {
        height: 100vh;
      }

      background-repeat: no-repeat;
      background-attachment: fixed;
      position: sticky;
      top: 0;

      img {
        object-fit: cover;
        width: 100%;
        height: 100vh;
      }

      @media (min-width: $switch-at) {
        img {
          object-fit: cover;
        }
      }

      &:not(:first-child) {
        background-color: white;
        @media (max-width: $switch-at) {
          img {
            object-fit: contain;
            object-position: center center;
          }
        }
      }
    }
  }

  .home-date {
    box-sizing: border-box;
    position: absolute;
    top: 75vh;
    z-index: 1000;

    &.za {
      @media (min-aspect-ratio: 2576 / 1566) {
        // wide
        right: calc((300 * (100vw / 2576)));
      }
      @media (max-aspect-ratio: 2576/1566) {
        // up to cheek
        right: 5%;
      }
      @media (max-aspect-ratio: 952 / 787) {
        // portrait
        left: 50%;
        top: 9rem;
        font-size: 150%;
        transform: translateX(-50%);

        @media (max-width: 388px) {
          top: 11rem;
        }
      }
    }

    &.uk {
      @media (min-aspect-ratio: 2576 / 1566) {
        // wide
        left: calc((300 * (100vw / 2576)));
      }
      @media (max-aspect-ratio: 2576/1566) {
        // up to cheek
        left: 5%;
      }
      @media (max-aspect-ratio: 952 / 787) {
        // portrait
        left: 50%;
        top: 5rem;
        font-size: 150%;
        transform: translateX(-50%);

        @media (max-width: 388px) {
          top: 7rem;
        }
      }
    }
    color: white;
    font-size: 300%;
    transform: translate(0, -50%);

    p {
      margin: 0;

      &:last-child {
        font-size: 1rem;
      }
    }
  }

  .home-down-arrow {
    position: absolute;
    top: 90vh;
    left: 50%;
    transform: translateX(-50%);
    color: rgba(255, 255, 255, 0.5);
  }

  img {
    .home-hero & {
      object-position: 40% center;
    }

    .home-2 & {
      object-position: 40% 40%;
    }

    .mariette-smile & {
      object-position: 70% center;
    }

    .rock & {
      object-position: 70% center;
    }

    .camping & {
      object-position: 35% 80%;
    }

    .stives & {
      object-position: center 70%;
    }

    .gs-wedding & {
      object-position: center 40%;
    }

    .snow-love & {
      object-position: center 40%;
    }
  }

</style>

<style lang="scss">

</style>
